import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { CircleCheck, CircleAlert } from 'lucide-react';
import './CxExpSonnerToast.css';

const AUTO_DISMISS_MS = 2800;

export function useCxExpToast() {
  const [toast, setToast] = useState(null);

  const dismiss = useCallback(() => setToast(null), []);

  const success = useCallback((message) => {
    setToast({ type: 'success', message: String(message || 'Operação concluída.') });
  }, []);

  const error = useCallback((message) => {
    setToast({ type: 'error', message: String(message || 'Ocorreu um erro.') });
  }, []);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(dismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [toast, dismiss]);

  const Toaster =
    toast &&
    createPortal(
      <div className="cx-exp-sonner-viewport" aria-live="polite">
        <div
          className={`cx-exp-sonner-toast cx-exp-sonner-toast--${toast.type}`}
          role={toast.type === 'error' ? 'alert' : 'status'}
        >
          <div className="cx-exp-sonner-toast-body">
            {toast.type === 'success' ? (
              <CircleCheck size={18} strokeWidth={2} className="cx-exp-sonner-icon cx-exp-sonner-icon--ok" aria-hidden />
            ) : (
              <CircleAlert size={18} strokeWidth={2} className="cx-exp-sonner-icon cx-exp-sonner-icon--err" aria-hidden />
            )}
            <div className="cx-exp-sonner-text">
              <p className="cx-exp-sonner-title">{toast.type === 'success' ? 'Sucesso' : 'Erro'}</p>
              <p className="cx-exp-sonner-desc">{toast.message}</p>
            </div>
          </div>
          <button type="button" className="cx-exp-sonner-dismiss" onClick={dismiss}>
            Fechar
          </button>
        </div>
      </div>,
      document.body
    );

  return { success, error, dismiss, Toaster };
}
